/**
 * @function batchDestroyNodes
 * @param  {Array} nodes {id|secure_random,file_type}
 * @return {undefined} This function return nothing.
 * You need to pass an array of objects identifying the nodes that needs to be destroyed
 */
export default nodes => {
  return $.ajax({
    type: "delete",
    url: "/api/v1/code_editor/batch_destroy",
    headers: {
      "x-csrf-token": $("meta[name='csrf-token']").attr("content")
    },
    data: {
      files: nodes,
      theme_id: CodeEditor.Main.themeId(),
      socket_id: window.socketId
    },
    success: function() {
      console.log("files deleted successfully");
      CodeEditor.Tree.reload();
    },
    error: function(xhr, ajaxOptions, thrownError) {
      console.log(thrownError);
      CodeEditor.Tree.reload();
    }
  });
};
